var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.48 28.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-C1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2824036625216",
    "data-name": 2824036625216
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.52,12.5c.61,1.94,1.89,5.17,2.65,7.22a12.87,12.87,0,0,1,1.65-.39c4-.52,8.66,1.43,11.63,3.67a3.34,3.34,0,0,0,.61.43A1.31,1.31,0,0,0,26.57,23c.41-.55.25-1,0-1.6l-2.74-7.55.35-.23a2.75,2.75,0,0,0,1-3.13,2.72,2.72,0,0,0-1.13-1.4L22,8.8a15.52,15.52,0,0,0-.55-1.57L19.68,2.44c-.19-.52-.36-1.08-.57-1.59a1.26,1.26,0,0,0-2.44.26A19.54,19.54,0,0,1,13.3,8.58,12.68,12.68,0,0,1,10,11.77c-.44.28-1,.46-1.44.72Z",
    transform: "translate(0 0.01)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29,21.53c.06.16,3.33,4.81,3.73,5.37a4.28,4.28,0,0,0,1,1.25,1.79,1.79,0,0,0,2.75-1.26,2.18,2.18,0,0,0-.62-1.72c-.31-.46-.63-.88-.93-1.34a31.33,31.33,0,0,1-2.71-4.12c-.12-.32-2.27-6.37-2.47-6.69-.92.27-3.35,1.19-4.38,1.58a7,7,0,0,0-2.07.9,1.92,1.92,0,0,0-.47,2.18l.79,2.17a6.4,6.4,0,0,0,.92,2.06c1.3,1.35,3-.12,4.43-.38Z",
    transform: "translate(0 0.01)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8,2.33a.7.7,0,0,0-.46.89c.16.61,1.2.59,2.51,1.69a8,8,0,0,1,2.44,3.15,8.27,8.27,0,0,1,.6,4.76c-.31,1.9-1.14,2.58-.89,3.2a.72.72,0,0,0,.95.37c.32-.13.43-.46.59-.79A9.71,9.71,0,0,0,29.37,4.28a8.25,8.25,0,0,0-1.57-1.2c-.35-.23-1.51-.94-2-.76Z",
    transform: "translate(0 0.01)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.49,5.66a.72.72,0,0,0-.34,1.17A5.7,5.7,0,0,1,27,9.47a4.71,4.71,0,0,1,.29,3.07,10.74,10.74,0,0,1-.5,1.33c-.18,1,1.64,1.88,2.06-1.7.51-4.39-3.51-6.81-4.36-6.52Z",
    transform: "translate(0 0.01)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/C1.fc81d1a94b5886183da04878ca8e3eb5.svg";
export { ForwardRef as ReactComponent };